module.exports = __webpack_public_path__ + "img/133-Gris Anthracite Lisse SFTN.jpg";